import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import { FeaBaseProcessService } from './fea-base-process.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeaCriticalAreasService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
  ) {
  }

  public async getResult(resultType: string): Promise<any> {
    const baseRequest = await this.feaBaseProcessService.getBaseProcessRequest();
    const request = {
      ...baseRequest,
      ResultType: resultType
    };

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      const valuesPerElement = await firstValueFrom(this.http.post<Map<number, number>>(environment.API_FEA + `CriticalArea/GetResult`, request, options));
      return {
        valuesPerElement: valuesPerElement,
        title: "FEA Critical Elements"
      };
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification("Failed to get critical area result");
      return null;
    }
  }
}
